/** One panel model for the whole workspace: rail · left context panel (Arbeid or Assistent) · work · right inspector.
 *  Sizes are design targets, remembered per user (not per case). The work surface always keeps a usable width. */
export const RAIL = { compact: 64, expanded: 240 };
export const RAIL_W = RAIL.compact;
export const MIN_WORK_W = 800; // the list keeps room for ref · title · one deviation · amount beside the panel; the panel yields width down to its minimum before it overlays

export const PANELS = {
  left: { key: "left", min: 240, def: 300, max: 400 },
  assist: { key: "assist", min: 320, def: 380, max: 560 },
  inspector: { key: "inspector", min: 480, def: 520, max: 720 },
  threads: { key: "threads", min: 250, def: 300, max: 400 },
};

const key = (name, user) => `sk.layout.${name}.${user?.id || "anon"}`;

export const readPref = (name, user) => localStorage.getItem(key(name, user));
export const writePref = (name, user, value) => { if (value == null) localStorage.removeItem(key(name, user)); else localStorage.setItem(key(name, user), String(value)); };

export const clampW = (p, w) => Math.round(Math.min(p.max, Math.max(p.min, Number(w) || p.def)));
export const readWidth = (p, user) => { const v = Number(readPref(`${p.key}.w`, user)); return v ? clampW(p, v) : p.def; };
export const writeWidth = (p, user, w) => writePref(`${p.key}.w`, user, w == null ? null : clampW(p, w));
